import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'onlynumbers',
  pure: false,
  standalone: true,
})
export class OnlyNumbersPipe implements PipeTransform {
  transform(value: string): string {
    return value.match(/\d/g)?.join('') || '';
  }
}
